import { useContext } from "react";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import { ChangePasswordActionContext } from "./ChangePasswordActionContext";
import usePrepareChangePassword from "./usePrepareChangePassword";
import useChangePassword from "./useChangePassword";
import { t } from "i18next";
import BeelditPasswordInput from "@beeldit/core/components/BeelditPasswordInput";

export default function useChangePasswordAction() {
  const prepareChangePassword = usePrepareChangePassword();
  const prepareChangePasswordFunction = (userId: number) => prepareChangePassword(userId);

  const onSuccess = () => setShowModal(false);
  const changePassword = useChangePassword();
  const changePasswordFunction = () => changePassword(onSuccess);

  const contextInstance = useContext(ChangePasswordActionContext);
  const { formData, setFormData, backendFormErrors, setShowModal } = contextInstance;

  const modalConfig = {
    contextInstance,
    title: "change_password",
    onSubmit: () => changePasswordFunction(),
  };

  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>
      <div className="row">
        <div className="col-12">
          <label className="form-label">{t("password")}</label>
          <BeelditPasswordInput
            id="admin-change-password"
            value={formData.password}
            onChange={(val: string) => setFormData({ ...formData, password: val })}
          />
          {backendFormErrors?.password && (
            <div className="invalid-feedback d-block">{backendFormErrors.password?.join?.(" ") || backendFormErrors.password}</div>
          )}
        </div>
        <div className="col-12 mt-3">
          <label className="form-label">{t("password_confirmation")}</label>
          <BeelditPasswordInput
            id="admin-change-password-confirmation"
            value={formData.password_confirmation}
            onChange={(val: string) => setFormData({ ...formData, password_confirmation: val })}
          />
          {backendFormErrors?.password_confirmation && (
            <div className="invalid-feedback d-block">{backendFormErrors.password_confirmation?.join?.(" ") || backendFormErrors.password_confirmation}</div>
          )}
        </div>
      </div>
      <small className="text-muted">
        {t("password")} (9-64, mayúsculas/minúsculas, número y símbolo).
      </small>
    </CrudModuleFactoryModal>
  );

  return {
    prepareChangePasswordFunction,
    actionTemplate,
  };
}

